export const TrackingEvent = 'community_click';

export enum TrackingTargetDefault {
    All = 'all',
}
